import { Observable } from 'rxjs';

export abstract class AbstractAuthService {
  public abstract isLoggedIn$: Observable<boolean>;
  constructor() {}
}
